import { GraduationCap } from "@phosphor-icons/react";

export function Logo({ size = 36, showText = true, light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <div
        className="grid place-items-center rounded-xl shadow-[0_6px_18px_rgba(255,75,10,0.35)]"
        style={{ width: size, height: size, background: "linear-gradient(135deg,#FF4B0A,#FFB800)" }}
      >
        <GraduationCap size={size * 0.6} weight="fill" color="#fff" />
      </div>
      {showText && (
        <div className="leading-none">
          <div className={`font-display font-extrabold tracking-tight text-[1.05rem] ${light ? "text-white" : "text-ink"}`}>
            YAYA<span className="text-terracotta"> EXAM</span>
          </div>
          <div className={`text-[0.6rem] tracking-[0.25em] uppercase ${light ? "text-white/70" : "text-muted-foreground"}`}>
            Academy
          </div>
        </div>
      )}
    </div>
  );
}
